import { formatFullName, formatSSN, getTagValue, getAttrValue, getEleArray, getTagAttrValue } from 'helpers/Helpers';
import React from 'react'

// summary of ALERTMESSAGEs from CREDITFILES
export default function SSNCheck({variations}) {
	//console.log("vars: ", variations, variations.length, typeof variations,);

	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>SSN Check Results</div>
			</div>
			<div className='w-full flex flex-col border-2'>
				{
					variations.map((cf, i) => {
						return (<CheckData key={i} cf={cf} />);
					})
				}
			</div>
		</div>
	)
}

function CheckData({cf}) {
	// get header data
	//console.log("cf: ",typeof cf, cf.length, cf);
	var fn = getTagAttrValue(cf, "_BORROWER", "_UnparsedName");
	var rep = getAttrValue(cf, "CreditFileID");
	var ssn = formatSSN(cf);
	// collect ALERTMESSAGEs
	//var msgs = cf2.ALERTMESSAGE;
	var msgs = getEleArray(cf, "_ALERT_MESSAGE");
	if (msgs === null) return;
	//console.log("msgs: ",typeof msgs, msgs.length, msgs);
	//console.log("msgs: ",typeof msgs, msgs);

	return (
		<div className='w-full flex flex-col pb-2 value'>
			<div className='flex flex-row'>
				<div className='w-[100px] pl-2 title'>Repository:</div>
				<div>{rep}</div>
			</div>
			<div className='flex flex-row'>
				<div className='w-1/12 pl-2 title'>Name:</div>
				<div className='w-5/12'>{fn}</div>
				<div className='w-1/12 title'>SSN:</div>
				<div className='w-5/12'>{ssn}</div>
			</div>
			<div className='flex flex-col'>
				{
					msgs.map((m, i) => {
						return (<Alerts key={i} alert={m} />)
					})
				}
			</div>
		</div>
	)
}

function Alerts({alert}) {

	var type = getAttrValue(alert, "_Type");
	var msg = getTagValue(alert, "_Text");

	return (
		<div className='flex flex-row value'>
			<div>{msg}</div>
		</div>
	)
}
